export const Themes = {
  light: {
    primary: '#2a29a4',
    background: '#ffffff',
    text: '#212529'
  },

  dark: {
    primary: '#4f46e5',
    background: '#0f172a',
    text: '#f8fafc'
  }
}